const landing_page = {
  aboutUs: "关于我们", // translated
  topPackages: "热门套餐", // translated
  featuredHotels: "特色酒店", // translated
  topTours: "热门旅游", // translated
  whatOurMembersSay: "我们的成员怎么说...", // translated
  followUsOnInstagram: "在 Instagram 上关注我们", // translated
  pleaseWait: "请稍等...", // translated
  packages: "套餐", // translated
  ourPartners: "我们的伙伴", // translated
  trustedCarHirePartners: "值得信赖的汽车租赁合作伙伴", // translated
  learnMore: "了解更多", // translated
};

export default landing_page;
